import React from "react";

export default function RequestStatus({ error, loading, onRetry }) {
  if (!error && !loading) return null;
  return <div role={error ? "alert" : "status"}
    className={`term-panel rounded-sm p-3 flex items-center justify-between flex-wrap gap-3 text-xs ${error ? "text-[#FF6b62]" : "text-slate-400"}`}>
    <span>{error || loading}</span>
    {error && onRetry && <button type="button" className="btn-x bg-[#232730] text-slate-100" onClick={onRetry}>Retry</button>}
  </div>;
}
